<script>
    export default {
        props: {
            placeholder: {
                type: String,
                default: 'Enter text...'
            },
            label: {
                type: String
            },
            value: {
                type: String
            },
        },
        data() {
            return {
                textInInput: this.value,
            }
        },
        watch: {
            textInInput(newValue) {
                this.$emit('input', newValue);
            }
        },
    }
</script>

<template>
    <div class="form-group">
        <label :for="'txt-'+label">
            <span class="font-bold" v-text="label"></span>
        </label>
        <input :id="'txt-'+label" type="text" v-model="textInInput" class="form-control" :placeholder="placeholder"/>
    </div>
</template>
